import React from 'react'

const ProductIcon = ({ size = 20, color = "#1A4673", ...props }) => {
  return (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 20 20" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M1.66669 3.33337V16.6667" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M4.16669 3.33337V16.6667" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M12.5 3.33337V16.6667" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M6.66669 15V5.00004C6.66669 4.21437 6.66669 3.82153 6.91076 3.57745C7.15484 3.33337 7.54768 3.33337 8.33335 3.33337C9.11902 3.33337 9.51185 3.33337 9.75594 3.57745C10 3.82153 10 4.21437 10 5.00004V15C10 15.7857 10 16.1785 9.75594 16.4226C9.51185 16.6667 9.11902 16.6667 8.33335 16.6667C7.54768 16.6667 7.15484 16.6667 6.91076 16.4226C6.66669 16.1785 6.66669 15.7857 6.66669 15Z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M15 15V5.00004C15 4.21437 15 3.82153 15.2441 3.57745C15.4882 3.33337 15.881 3.33337 16.6667 3.33337C17.4523 3.33337 17.8452 3.33337 18.0892 3.57745C18.3333 3.82153 18.3333 4.21437 18.3333 5.00004V15C18.3333 15.7857 18.3333 16.1785 18.0892 16.4226C17.8452 16.6667 17.4523 16.6667 16.6667 16.6667C15.881 16.6667 15.4882 16.6667 15.2441 16.4226C15 16.1785 15 15.7857 15 15Z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}

export default ProductIcon
